<template>
  <div>
    <Transition name="slide-fade">
      <q-card
        v-if="props.rightDrawerOpen"
        class="drawer-modal text-brand-1"
        :class="classTitulo"
      >
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="fecharModal()"
              />
              <span style="font-size: 16px">
                <span>
                  <span class="texto-titulo-modal" :class="classTitulo">
                    {{ nomeModal }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <q-scroll-area
          v-if="tipoModal == 'scroll'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 80%"
          >
            <div class="q-px-md text-weight-bold">
              <slot name="conteudo-modal"></slot>
            </div>
            <div class="row q-px-md q-mt-xs">
              <slot name="botao-modal"></slot>
            </div>
          </div>
        </q-scroll-area>
        <div
          v-else
          class="column justify-between no-wrap"
          style="width: 100%; height: 88%"
        >
          <div class="q-px-md text-weight-bold">
            <slot name="conteudo-modal"></slot>
          </div>
          <div class="row q-px-md q-mt-md">
            <slot name="botao-modal"></slot>
          </div>
        </div>
      </q-card>
    </Transition>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  rightDrawerOpen: Boolean,
  nomeModal: String,
  tipoModal: String,
  classTitulo: String,
});

const emits = defineEmits(["fecharModal"]);

const fecharModal = () => {
  emits("fecharModal");
};
</script>

<style scoped>
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: 85%;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    width: 100vw !important;
    height: calc(100vh - 60px) !important;
    max-height: calc(100vh - 60px) !important;
    top: 60px !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    border: none !important;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(100vw);
  }

  /* Ajuste do cabeçalho do modal para mobile - mantendo padrão original */
  .drawer-modal .q-pa-md:first-child {
    padding: 8px 12px !important;
    min-height: 40px !important;
  }

  /* Ajuste da área de scroll para mobile */
  .drawer-modal .q-scroll-area {
    height: calc(100vh - 160px) !important;
  }

  /* Para modal sem scroll - mais compacto */
  .drawer-modal .column.justify-between {
    height: calc(100vh - 160px) !important;
    padding: 0 !important;
  }

  /* Reduz espaçamento entre campos */
  .drawer-modal .q-px-md {
    padding: 6px 12px !important;
  }

  /* Espaçamento específico para área de conteúdo */
  .drawer-modal .q-px-md.text-weight-bold {
    padding-top: 12px !important;
    padding-bottom: 6px !important;
  }

  /* Área do botão mais compacta - sem linhas */
  .drawer-modal .row.q-px-md.q-mt-md {
    padding: 12px !important;
    margin-top: 6px !important;
  }

  .texto-titulo-modal {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .drawer-modal {
    width: 100vw !important;
    height: calc(100vh - 50px) !important;
    max-height: calc(100vh - 50px) !important;
    top: 125px !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    border: none !important;
  }

  /* Cabeçalho ainda mais compacto */
  .drawer-modal .q-pa-md {
    padding: 6px 10px !important;
    min-height: 35px !important;
  }

  .drawer-modal .q-px-md {
    padding: 4px 10px !important;
  }

  .drawer-modal .q-scroll-area {
    height: calc(100vh - 140px) !important;
  }

  .drawer-modal .column.justify-between {
    height: calc(100vh - 140px) !important;
  }

  /* Espaçamento do conteúdo */
  .drawer-modal .q-px-md.text-weight-bold {
    padding-top: 10px !important;
    padding-bottom: 4px !important;
  }

  /* Área do botão */
  .drawer-modal .row.q-px-md.q-mt-md {
    padding: 10px !important;
    margin-top: 4px !important;
    margin-bottom: 150px;
  }
  .texto-titulo-input {
    font-size: 13px;
    margin-bottom: 6px;
    font-weight: 600;
  }

  .texto-titulo-modal {
    font-size: 18px;
    line-height: 1.2;
  }
}

@media (max-width: 360px) {
  .drawer-modal {
    width: 100vw !important;
    height: calc(100vh - 45px) !important;
    max-height: calc(100vh - 45px) !important;
    top: 45px !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    border: none !important;
  }

  /* Cabeçalho ultra compacto */
  .drawer-modal .q-pa-md {
    padding: 4px 8px !important;
    min-height: 30px !important;
  }

  .drawer-modal .q-px-md {
    padding: 3px 8px !important;
  }

  .drawer-modal .q-scroll-area {
    height: calc(100vh - 120px) !important;
  }

  .drawer-modal .column.justify-between {
    height: calc(100vh - 120px) !important;
  }

  /* Espaçamento mínimo do conteúdo */
  .drawer-modal .q-px-md.text-weight-bold {
    padding-top: 8px !important;
    padding-bottom: 3px !important;
  }

  /* Área do botão mínima */
  .drawer-modal .row.q-px-md.q-mt-md {
    padding: 8px !important;
    margin-top: 3px !important;
  }

  .texto-titulo-modal {
    font-size: 12px;
    line-height: 1.1;
  }
}
</style>
